<template>
  <div>
    <template v-if="hayLanzador">
      <button v-if="esTooltip" class="btn" :class="btnClass" data-toggle="modal" :data-target="`#${id}`" v-tooltip :title="titulo"><i :class="icono"></i></button>
      <button v-else class="btn" :class="btnClass" data-toggle="modal" :data-target="`#${id}`"><i class="mr-1" :class="icono"></i>{{ titulo }}</button>
    </template>
    <div ref="modal" :id="id" class="modal fade" data-backdrop="static" :data-keyboard="esCerrable ? 'true' : 'false'" tabindex="-1" :aria-labelledby="label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" :class="clases">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" :id="label">{{ titulo }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" :hidden="cierreForzado || !esCerrableDefinitivo">
              <small aria-hidden="true"><i class="fa-solid fa-xmark"></i></small>
            </button>
          </div>
          <slot v-if="$slots.prebody" name="prebody"></slot>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
          <div v-if="$slots.footer" class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modal",
  props: {
    titulo: String,
    icono: String,
    loading: Boolean,
    clases: Array,
    esCerrable: {
      type: Boolean,
      default: true,
    },
    btnClass: {
      type: String,
      default: "btn-primary",
    },
    hayLanzador: {
      type: Boolean,
      default: true,
    },
    esTooltip: {
      type: Boolean,
      default: false,
    },
    modalId: String,
  },
  data() {
    return {
      cierreForzado: false,
    }
  },
  computed: {
    id: function () {
      return `modal-${this.modalId ?? this.titulo.replace(/[^a-zA-Z]/gm, "").toLowerCase()}`;
    },
    label: function () {
      return `label-${this.id}`;
    },
    esCerrableDefinitivo: function () {
      return this.cierreForzado || (this.esCerrable && !this.loading);
    },
  },
  methods: {
    abrir: function () {
      $(this.$refs.modal).modal("show");
    },
    cerrar: function () {
      this.cierreForzado = true;

      $(this.$refs.modal).modal("hide");
    },
  },
  mounted: function () {
    $(this.$refs.modal)
      .on("shown.bs.modal", () => this.$emit("abrir"))
      .on("hidden.bs.modal", () => {
        this.$emit("cerrar");

        this.cierreForzado = false;
      })
      .on("hide.bs.modal", () => (this.esCerrableDefinitivo));
  },
};
</script>